import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20luxury%20lounge%20with%20warm%20golden%20lighting%2C%20sophisticated%20entertainment%20atmosphere%2C%20abstract%20flowing%20light%20patterns%20in%20champagne%20and%20ivory%20tones%2C%20premium%20hospitality%20setting%2C%20soft%20bokeh%20background%20with%20inviting%20warmth&width=1920&height=800&seq=cta-bg-sun&orientation=landscape"
          alt="加入太阳娱乐"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
          准备好开启您的精彩娱乐之旅了吗？
        </h2>
        <p className="text-background-50/80 mb-8 max-w-xl mx-auto">
          立即加入太阳娱乐，与5000万+用户一起畅享顶级娱乐体验。注册即享新人专属福利！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            立即注册
          </Link>
          <Link
            to="/articles"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg text-base font-semibold border-2 border-background-50/40 text-background-50 hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap"
          >
            浏览文章
          </Link>
        </div>
      </div>
    </section>
  );
}